import {decorate, observable, action} from "mobx"
import {stateIdToName, dmaCodeToName} from "../../utils/utils"

export class InsightsStore {
  brandId = 25
  insightType = "Market Share"
  insightMonth = ""
  lastMonth = ""
  availableMonths = []
  insightMarketType = "National"
  insightMarketTypeValue = [0]
  insightMarketTypeValueName = "US"
  competitorBrands = []
  insightBehavioralAudience = ""
  insightBehavioralAudienceList = []
  sicCodes = []
  brandIds = []
  brandCategoryMap = ""
  defaultInsights = 0

  setBrandId(brandId) {
    this.brandId = brandId
  }

  setCategoryId(categoryId) {
    this.categoryId = categoryId
  }

  setInsightType(insightType) {
    this.insightType = insightType
  }

  setInsightMonth(month) {
    this.insightMonth = month
  }

  setLastMonth(month) {
    this.lastMonth = month
  }

  setAvailableMonths(months) {
    this.availableMonths = months
  }

  setInsightMarketType(type) {
    this.insightMarketType = type
  }

  setInsightMarketTypeValue(value) {
    this.insightMarketTypeValue = value
  }

  setCompetitorBrands(value) {
    this.competitorBrands = value
  }

  setInsightBehaviouralAudience(value) {
    this.insightBehavioralAudience = value
  }

  setInsightBehaviouralAudienceList(value) {
    this.insightBehavioralAudienceList = value
  }

  setSicCodes(value) {
    this.sicCodes = value
  }

  setBrandIds(value) {
    this.brandIds = value
  }

  setBrandCategoryMap(value) {
    this.brandCategoryMap = value
  }

  setDefaultInsights() {
    this.defaultInsights += 1
  }

  setInsightMarketTypeValueName(value) {
    this.insightMarketTypeValueName = value
  }

  setInsightMarketTypeFromGeo(geoTimeObj) {
    const geoType = geoTimeObj.geo.geoType
    if (geoType === "STATE") {
      this.setInsightMarketType("State")
    } else if (geoType === "DMA") {
      this.setInsightMarketType("DMA")
    } else {
      this.setInsightMarketType("National")
    }
  }

  setInsightMarketTypeValueFromGeo(geoTimeObj) {
    const geoType = geoTimeObj.geo.geoType
    const geoId = geoTimeObj.geo.geoId
    if (geoType === "STATE") {
      const stateName = stateIdToName(geoId)
      this.setInsightMarketTypeValueName([stateName])
    } else if (geoType === "DMA") {
      const dmaName = dmaCodeToName(geoId)
      this.setInsightMarketTypeValueName([dmaName])
    } else {
      this.setInsightMarketTypeValueName("US")
    }
    this.setInsightMarketTypeValue([geoId])
  }
}

decorate(InsightsStore, {
  brandId: observable,
  categoryId: observable,
  insightType: observable,
  insightMonth: observable,
  lastMonth: observable,
  availableMonths: observable,
  insightMarketType: observable,
  insightMarketTypeValue: observable,
  defaultInsights: observable,
  competitorBrands: observable,
  insightBehavioralAudience: observable,
  insightBehavioralAudienceList: observable,
  sicCodes: observable,
  brandIds: observable,
  brandCategoryMap: observable,
  insightMarketTypeValueName: observable,
  setBrandId: action,
  setCategoryId: action,
  setInsightType: action,
  setInsightMonth: action,
  setLastMonth: action,
  setAvailableMonths: action,
  setInsightMarketType: action,
  setInsightMarketTypeValue: action,
  setDefaultInsights: action,
  setCompetitorBrands: action,
  setInsightBehaviouralAudience: action,
  setInsightBehaviouralAudienceList: action,
  setSicCodes: action,
  setBrandIds: action,
  setBrandCategoryMap: action,
  setInsightMarketTypeFromGeo: action,
  setInsightMarketTypeValueFromGeo: action,
  setInsightMarketTypeValueName: action,
})
